module.exports = __webpack_public_path__ + "static/media/arvel-crynyd.1ed1f42d.jpg";